module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.137a9f5f.woff";